/**
 * Barrel for MSW handlers, grouped by domain. Consumers:
 *
 *   - `src/mocks/browser.js`      — browser Service Worker (e2e mode)
 *   - `src/tests/mocks/server.js` — Node `setupServer` (jest / vitest)
 *
 * Split domains into their own file (e.g. `./auth`, `./paymentProof`) as
 * coverage grows. Keep this file the sole public surface so both entry
 * points stay identical.
 */
export { authHandlers } from './auth'
export { paymentProofHandlers } from './paymentProof'

import { authHandlers } from './auth'
import { paymentProofHandlers } from './paymentProof'

export const handlers = [...authHandlers, ...paymentProofHandlers]
